import Vue from 'vue';
import store from './store/store'
import BuyZoneApp from './BuyZoneApp.vue';
import NavigationApp from './NavigationApp.vue';
import ProductsApp from './ProductsApp.vue';
import MiniCartApp from './MiniCartApp.vue';
import GlsApp from './GlsApp.vue'
import SearchApp from './SearchApp.vue'
import SearchResultsApp from './SearchResultsApp.vue'

// Navigation App
if(document.getElementById('navigation') !== null){
    new Vue({ 
        render: createElement => createElement(NavigationApp) 
    }).$mount('#navigation');
}

// Buy zone App
if(document.getElementById('buyzone') !== null){
    new Vue({ 
        store: store,
        render: createElement => createElement(BuyZoneApp) 
    }).$mount('#buyzone');
}

// Product search App
if(document.getElementById('products') !== null){
    new Vue({ 
        store: store,
        render: createElement => createElement(ProductsApp) 
    }).$mount('#products');
}

// Mini cart App
if(document.getElementById('miniCart') !== null){
    new Vue({ 
        render: createElement => createElement(MiniCartApp) 
    }).$mount('#miniCart');
}

// GLS Pickup Locations App
if(document.getElementById('glsPickupPoints') !== null){
    new Vue({ 
        render: createElement => createElement(GlsApp) 
    }).$mount('#glsPickupPoints');
}

// Search App
if(document.getElementById('searchApp') !== null){
    new Vue({ 
        render: createElement => createElement(SearchApp) 
    }).$mount('#searchApp');
}

// Search Results App
if(document.getElementById('searchResultsApp') !== null){
    new Vue({ 
        render: createElement => createElement(SearchResultsApp) 
    }).$mount('#searchResultsApp');
}
